import { render, staticRenderFns } from "./BaseDisplayListModal.vue?vue&type=template&id=d9b2a704&scoped=true&"
import script from "./BaseDisplayListModal.vue?vue&type=script&lang=js&"
export * from "./BaseDisplayListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b2a704",
  null
  
)

export default component.exports